import { ToastSettings } from '../../../interfaces';
import { smallDialogSettingsInitial } from '../constants';
import { NotificationsAction } from '../notificationsProvider.enums';
import { NotificationsActions, NotificationsState } from '../notificationsProvider.types';

export const notificationsReducer: (state: NotificationsState, action: NotificationsActions) => NotificationsState = (
  state: NotificationsState, action: NotificationsActions
): NotificationsState => {
  switch (action.type) {
    case NotificationsAction.AddToast:
      return { ...state, toasts: [...state.toasts, action.payload] };
    case NotificationsAction.RemoveToast:
      return {
        ...state,
        toasts: state.toasts.filter((toast: ToastSettings) => toast.content !== action.payload),
      };
    case NotificationsAction.ClearToasts:
      return { ...state, toasts: [] };
    case NotificationsAction.ShowSmallDialog:
      return { ...state, smallDialogSettings: action.payload };
    case NotificationsAction.SetSmallDialogIsLoading:
      return { ...state, smallDialogSettings: { ...state.smallDialogSettings, isLoading: true } };
    case NotificationsAction.HideSmallDialog:
      return { ...state, smallDialogSettings: smallDialogSettingsInitial };
    case NotificationsAction.UpdateAcceptButtonLabel:
      return {
        ...state,
        smallDialogSettings: {
          ...state.smallDialogSettings,
          acceptButton: {
            ...state.smallDialogSettings.acceptButton,
            label: action.payload,
          }
        }
      };
    default:
      return state;
  }
};
